import { ObjectExt } from '../../util';
import { Base } from '../base';
export function getMarkup(tagName) {
  let selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'body';
  return [{
    tagName,
    selector
  }, {
    tagName: 'text',
    selector: 'label'
  }];
}
export function createShape(shape, config) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const defaults = {
    constructorName: shape,
    markup: getMarkup(shape, options.selector),
    attrs: {
      [shape]: Object.assign({}, Base.bodyAttr)
    }
  };
  const base = options.parent || Base;
  return base.define(ObjectExt.merge(defaults, config, {
    shape
  }));
}